import React from "react";
import './Card.css';

function Card({title, image, body, onClick}){
    return(
       <div onClick={onClick}>
            <div className="tutorial-contents">
                <img className="tutorial-image" src={image} alt=''/>
                <span className="tutorial-title ">{title}</span>
                <span className="tutorial-arrow">&rsaquo;</span>
            </div>
            {/* <p className="card-text">{body}</p> */}
       </div> 
    );
}

export default Card